import { useLazyQuery as b } from "@apollo/client";
import { useFrontendConfigContext as O } from "../../../config-lib/contexts/FrontendConfigContext.js";
import { currencyOffchainTokenSchema as x } from "../../deserialize/yup/currency.js";
import F from "../../graphql/query/getOffChainTokenBalances.js";
import * as t from "ramda";
import { useState as C, useCallback as l } from "react";
const v = () => {
  const { waitConfig: h } = O(), [g, { loading: E }] = b(F), [p, T] = C({}), [u, w] = C({}), N = l(
    (e, s) => t.reduce(
      (o, a) => {
        const n = t.prop(
          a,
          s
        );
        return t.concat(
          t.isNotNil(n) ? n.assets : [a],
          o
        );
      },
      [],
      e
    ),
    []
  ), k = l(
    (e, s, o) => {
      const a = t.prop(
        e,
        s
      ), n = t.filter(
        (r) => t.includes(r.assetName, (a == null ? void 0 : a.assets) || []),
        o
      );
      if (t.isNotEmpty(n))
        return n;
      const i = t.find((r) => r.assetName === e, o);
      return t.isNotNil(i) ? [i] : [];
    },
    []
  ), y = l((e) => {
    let s = BigInt(0);
    return t.forEach((o) => {
      s += BigInt(o.amount || "0");
    }, e), s.toString();
  }, []), B = l(async () => {
    const e = await h(), s = (e == null ? void 0 : e.supportToken.allTokens.offChain) || [], o = (e == null ? void 0 : e.relatedAsset) || {};
    if (t.isEmpty(s))
      return {
        grouped: {},
        flatten: {}
      };
    const a = N(s, o), n = await g({
      variables: {
        input: {
          rewardNames: a
        }
      }
    }), i = t.pathOr(
      [],
      ["data", "getClaimableRewardBalances"],
      n
    ), r = t.map(
      (c) => x.cast(c),
      i
    );
    let m = {};
    t.forEach((c) => {
      const d = k(c, o, r);
      if (t.isNotEmpty(d)) {
        const S = y(d), R = t.head(d);
        m = t.assoc(R.type, String(S), m);
      }
    }, s), T(m);
    let f = {};
    return t.forEach((c) => {
      f = t.assoc(c.type, String(c.amount || "0"), f);
    }, r), w(f), {
      grouped: p,
      flatten: u
    };
  }, [
    h,
    N,
    g,
    p,
    u,
    k,
    y
  ]);
  return {
    grouped: p,
    flatten: u,
    loading: E,
    fetch: B
  };
};
export {
  v as default
};
//# sourceMappingURL=useGetOffChainTokenBalances.js.map
